var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup808(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(-80 -604)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    transform: "translate(80 604)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812",
    transform: "translate(513.328 485.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    "data-name": "Path 3944",
    d: "M-410.91,146.478c0-1.742-.046-3.4.009-5.058a9.679,9.679,0,0,1,5.766-9,9.934,9.934,0,0,1,14.1,7.64,43.3,43.3,0,0,1,.125,4.858c.009.486,0,.973,0,1.532.245.012.45.03.655.03,1.817,0,3.634-.006,5.451,0a3.721,3.721,0,0,1,3.893,3.909c0,1.168,0,2.336,0,3.558a4.228,4.228,0,0,0-3,1.548,8.566,8.566,0,0,1-6.069,2.625,3.419,3.419,0,0,0-3.422,3.4c-.047,2.85-.115,5.715.119,8.55a14.653,14.653,0,0,0,6.2,11.136,2.414,2.414,0,0,1,.188.182,4,4,0,0,1-.46.058q-14.887,0-29.775-.012a3.642,3.642,0,0,1-3.758-3.786q-.014-13.686,0-27.372a3.658,3.658,0,0,1,3.807-3.8c1.817-.013,3.634,0,5.451,0Zm15-.024c0-1.738.014-3.415,0-5.092a5.015,5.015,0,0,0-4.653-4.916,4.785,4.785,0,0,0-5.159,3.826,47.522,47.522,0,0,0-.159,6.069c0,.03.042.06.083.113Zm-1.26,17.481a3.733,3.733,0,0,0-3.771-3.732,3.788,3.788,0,0,0-3.747,3.781,3.79,3.79,0,0,0,3.8,3.733A3.735,3.735,0,0,0-397.166,163.935Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3945",
    "data-name": "Path 3945",
    d: "M-144.8,353.873a55.7,55.7,0,0,1-.62,6.271c-.938,4.485-3.886,7.327-7.992,9.127a3.513,3.513,0,0,1-3.056.006c-4.307-1.883-7.214-4.919-8.141-9.628a16.523,16.523,0,0,1-.3-2.847c-.044-2.207-.021-4.415-.018-6.623,0-.859.3-1.19,1.135-1.215a11.271,11.271,0,0,0,7.8-3.537c.88-.872,1.213-.873,2.082-.011a11.446,11.446,0,0,0,6.334,3.4c.519.083,1.049.1,1.574.142a.967.967,0,0,1,1.029,1.085c.012,1.27,0,2.54,0,3.81Z",
    transform: "translate(-225.955 -188.316)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup808);
export default __webpack_public_path__ + "static/media/Group 808.b2f4fc0d5ca08a3568eff400ff3b8bde.svg";
export { ForwardRef as ReactComponent };